export enum AiDocumentType {
  CIN_CARD = 'CIN_CARD',
  CNSS_CARD = 'CNSS_CARD',
  BIRTH_CERTIFICATE = 'BIRTH_CERTIFICATE',
  RIB_CERTIFICATE = 'RIB_CERTIFICATE',
}

export enum AiJobStatus {
  NOT_STARTED = 'NOT_STARTED',
  PENDING = 'PENDING',
  STARTED = 'STARTED',
  SUCCESS = 'SUCCESS',
  FAILURE = 'FAILURE',
  LOW_CONFIDENCE_REVIEW = 'LOW_CONFIDENCE_REVIEW',
  FAILED_VALIDATION = 'FAILED_VALIDATION',
  AI_SERVICE_UNAVAILABLE = 'AI_SERVICE_UNAVAILABLE',
  QUEUE_UNAVAILABLE = 'QUEUE_UNAVAILABLE',
  OCR_FAILED = 'OCR_FAILED',
  FILE_NOT_ACCESSIBLE = 'FILE_NOT_ACCESSIBLE',
  RETRIED = 'RETRIED',
  ACCEPTED = 'ACCEPTED',
  REJECTED = 'REJECTED',
  EDITED = 'EDITED',
}

export enum AiComparisonStatus {
  MATCH = 'MATCH',
  MISMATCH = 'MISMATCH',
  MISSING_MANUAL_VALUE = 'MISSING_MANUAL_VALUE',
  MISSING_AI_VALUE = 'MISSING_AI_VALUE',
  LOW_CONFIDENCE = 'LOW_CONFIDENCE',
  NOT_COMPARABLE = 'NOT_COMPARABLE',
}

export enum AiDecisionAction {
  ACCEPT_AI = 'ACCEPT_AI',
  KEEP_MANUAL = 'KEEP_MANUAL',
  EDIT_MANUALLY = 'EDIT_MANUALLY',
  RETRY_EXTRACTION = 'RETRY_EXTRACTION',
}

export interface AiValidationField {
  field: string;
  label: string;
  manualValue?: string;
  aiValue?: string;
  confidence?: number;
  comparisonStatus: AiComparisonStatus;
  warning?: string;
}

export interface AiValidationResult {
  documentId: number;
  documentType: AiDocumentType;
  status: AiJobStatus;
  fields: AiValidationField[];
  warnings: string[];
  error?: string;
}

export interface AiFieldDecision {
  action: AiDecisionAction;
  finalValue?: string;
}

export interface AiDecisionRequest {
  decisions: { [key: string]: AiFieldDecision };
}

export interface AiJobResponse {
  jobId: string;
  status: string;
}
